<template>
  <div
    v-if="providers.length > 0"
    class="social-login"
  >
    <div
      class="flex flex-wrap flex-column between-xs"
    >
      <base-button
        v-for="(provider, index) in providers"
        :key="index"
        :data-testid="'SocialLogin' + provider"
        class="social-login-provider-button c-primary justify-center lh16 flex middle-xs mb10"
        :class="['provider-' + provider]"
        @click.native="AuthProvider(provider)"
      >
        <i
          class="fs16 icon mr15 vertical-middle lh16 mla"
          :class="['icon-' + provider]"
        />
        <span class="vertical-middle lh29 mra">
          {{ $t('Continue with') }}&nbsp;
        </span>
        <span class="vertical-middle capitalize lh29 mra">
          {{ provider }}
        </span>
      </base-button>
    </div>
    <div class="login-method-separator text-center mt20 mb30 flex around-xs relative">
      <span class="fs18 lh15 ls0 c-gray lowercase weight-700 px20 c-bg-white relative">
        {{ $t('or') }}
      </span>
    </div>
  </div>
</template>

<script>
import BaseButton from '../../BaseButton'
import i18n from '@vue-storefront/i18n'
import { social_login } from 'config'
import { mapState } from 'vuex'

export default {
  components: {
    BaseButton
  },
  data () {
    return {
      providers: Object.keys(social_login.providers)
    }
  },
  computed: {
    ...mapState({
      orderState: state => state.order
    }),
    orderId () {
      return this.orderState?.last_order_confirmation?.confirmation?.backendOrderId || null
    }
  },
  methods: {
    AuthProvider (provider) {
      let self = this
      this.$bus.$emit('notification-progress-start', i18n.t('Authorization in progress ...'))
      this.$auth.authenticate(provider)
        .then(response => {
          self.SocialLogin(provider, response)
        })
        .catch(() => {
          this.hideModalOverlay()
          this.popUpErrorMessage('Social Login unsuccessful')
        })
    },
    SocialLogin (provider, response) {
      this.$store.dispatch('social-login/auth', { type: provider, data: response, orderId: this.orderId })
        .then(() => {
          this.hideModalOverlay()
          this.$parent.onSuccess()
        })
        .catch(() => {
          this.hideModalOverlay()
          this.popUpErrorMessage('Social Login unsuccessful')
        })
    },
    popUpErrorMessage (message) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(message),
        action1: { label: this.$t('OK') }
      })
    },
    hideModalOverlay () {
      this.$bus.$emit('notification-progress-stop', {})
      this.$bus.$emit('modal-hide', 'modal-signup')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/grid';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

.social-login-provider-button {
  background-color: white;
  border: 1px solid #94949233;
  height: 69px;
  font-size: 24px;

  .icon {
    width: 25px;
    height: 25px;
  }

  /deep/ .capitalize {
    text-transform: capitalize;
  }

  .icon-facebook::before {
    content: "";
  }
}

.login-method-separator {
  &::before {
    display: block;
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    left: 0;
    top: 7px;
    background-color: #94949233;
    z-index: 1;
  }

  span {
    z-index: 2;
    color: #6c6c6c;
  }
}

@media (max-width: 400px) {
  .social-login-provider-button {
    font-size: 20px;
    height: 59px;
  }

  .icon {
    width: 23px;
    height: 23px;
  }
}

@include desktop() {
  .social-login-provider-button {
    padding: 0 10px;

    /deep/ .icon-facebook,
    /deep/ .icon-google {
      margin-right: 10px;
      display: inline-block;
      margin-top: 0;
    }
  }
}
</style>
